/* SHEEP Device (my device highlighter) — moved out of snippets/sheep-my-device.liquid on 1 Nov 2026 (SPEED, Microsoft Clarity):
   the code is now a cached file (was 32KB inline on every page). Page values come from window.__SMD, written by the snippet.
   Must load AFTER assets/sheep-device-check.js (both "defer", same order as in snippets/head.is-land.liquid).
   Backup of the inline version: snippets/zz-backup-sheep-my-device-before-asset-2026-11-01.liquid */
(function(){
  var CFG = window.__SMD || {};
  var KEY = 'sheep_my_device', P = 'filter.p.m.custom.compatible_models', MAX = 3;
  var PT = CFG.pt || '';
  var HANDLE = CFG.handle || null;
  var CM = CFG.cm || null; if (CM) CM = CM.filter(function(x){ return typeof x === 'string'; });
  var OPT = CFG.opt || '', COMPAT = CFG.compat || null;

  var CATS = [
    { k:'phone', n:'มือถือ', sub:'iPhone · Samsung Galaxy · OPPO', g:[
      { n:'iPhone', m:['iPhone Duo','iPhone 18 Pro Max','iPhone 18 Pro','iPhone 17 Pro Max','iPhone 17 Pro','iPhone Air','iPhone 17','iPhone 16e','iPhone 16 Pro Max','iPhone 16 Pro','iPhone 16 Plus','iPhone 16','iPhone 15 Pro Max','iPhone 15 Pro','iPhone 15 Plus','iPhone 15','iPhone 14 Pro Max','iPhone 14 Pro','iPhone 14 Plus','iPhone 14','iPhone 13 Pro Max','iPhone 13 Pro','iPhone 13','iPhone 12 Pro Max','iPhone 12 Pro','iPhone 12','iPhone 11 Pro Max','iPhone 11 Pro','iPhone 11'] },
      { n:'Samsung Galaxy', m:['Samsung S26 Ultra','Samsung S25 Ultra','Samsung S24 Ultra','Samsung S23 Ultra'] },
      { n:'OPPO', m:['OPPO Reno16 Pro','OPPO Reno16'] }
    ] },
    { k:'ipad', n:'iPad', sub:'', g:[ { n:'iPad', m:['iPad Air 13" (M4)','iPad Air 11" (M4)','iPad Pro 13" (M5)','iPad Pro 11" (M5)','iPad Air 13" (M3)','iPad Air 11" (M3)','iPad 11" (11th gen)','iPad mini 7','iPad Pro 13" (M4)','iPad Pro 11" (M4)','iPad Air 13" (M2)','iPad Air 11" (M2)','iPad Pro 12.9" (6th gen, M2)','iPad Pro 11" (4th gen, M2)','iPad 10.9" (10th gen)','iPad Air (5th gen) 10.9"','iPad mini 6','iPad 10.2" (9th gen)','iPad Pro 12.9" (5th gen, M1)','iPad Pro 11" (3rd gen, M1)','iPad Air (4th gen) 10.9"','iPad 10.2" (8th gen)','iPad Pro 12.9" (4th gen)','iPad Pro 11" (2nd gen)','iPad 10.2" (7th gen)','iPad Air (3rd gen) 10.5"','iPad Pro 12.9" (3rd gen)','iPad Pro 11" (1st gen)','iPad 9.7" (6th gen)','iPad Pro 10.5"'] } ] },
    { k:'airpods', n:'AirPods', sub:'', g:[ { n:'AirPods', m:['AirPods Pro 3','AirPods 5','AirPods 4','AirPods Pro 2','AirPods 3','AirPods Pro 1','AirPods 2','AirPods 1'] } ] },
    { k:'macbook', n:'MacBook', sub:'', g:[
      { n:'MacBook Neo', m:['MacBook Neo'] },
      { n:'MacBook Air', m:['MacBook Air 15" (M5)','MacBook Air 13" (M5)','MacBook Air 15" (M4)','MacBook Air 13.6" (M4)','MacBook Air 15" (M3)','MacBook Air 13.6" (M3)','MacBook Air 15" (M2)','MacBook Air 13.6" (M2)','MacBook Air 13.3" (M1)','MacBook Air 13.3" (Intel 2018–2020)'] },
      { n:'MacBook Pro', m:['MacBook Pro 16" (M5 Pro/Max)','MacBook Pro 14" (M5 / M5 Pro / M5 Max)','MacBook Pro 16" (M4 Pro/Max)','MacBook Pro 14" (M4 family)','MacBook Pro 16" (M3 Pro/Max)','MacBook Pro 14" (M3 family)','MacBook Pro 16" (M2 Pro/Max)','MacBook Pro 14" (M2 Pro/Max)','MacBook Pro 13" (M2)','MacBook Pro 16" (M1 Pro/Max)','MacBook Pro 14" (M1 Pro/Max)','MacBook Pro 13" (M1)','MacBook Pro 16" (Intel 2019)','MacBook Pro 13" (Intel 2016–2020)'] }
    ] },
    { k:'pencil', n:'Apple Pencil', sub:'', g:[ { n:'Apple Pencil', m:['Apple Pencil Pro','Apple Pencil (USB-C)','Apple Pencil (2nd gen)','Apple Pencil (1st gen)'] } ] }
  ];
  var LN = { iphone:'iPhone', samsung:'Samsung Galaxy', oppo:'OPPO', ipad:'iPad', airpods:'AirPods', macbook:'MacBook', pencil:'Apple Pencil' };
  var LINE_CAT = { iphone:'phone', samsung:'phone', oppo:'phone', ipad:'ipad', airpods:'airpods', macbook:'macbook', pencil:'pencil' };
  var MENU_LINE = { 'iphone':'iphone', 'samsung galaxy':'samsung', 'samsung':'samsung', 'oppo':'oppo', 'ipad':'ipad', 'airpods':'airpods', 'macbook':'macbook', 'apple pencil':'pencil' };
  var ALL = []; CATS.forEach(function(C){ C.g.forEach(function(G){ ALL = ALL.concat(G.m); }); });

  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); }
  function norm(s){ return String(s || '').toLowerCase().replace(/[“”″]/g, '"').replace(/magsafe/g, '').replace(/\s+/g, ' ').trim(); }
  function lineOf(s){
    s = String(s || '').toLowerCase().trim();
    if (s.indexOf('iphone') === 0) return 'iphone';
    if (s.indexOf('samsung') === 0 || s.indexOf('galaxy') === 0) return 'samsung';
    if (s.indexOf('oppo') === 0) return 'oppo';
    if (s.indexOf('ipad') === 0) return 'ipad';
    if (s.indexOf('airpods') === 0) return 'airpods';
    if (s.indexOf('macbook') === 0) return 'macbook';
    if (s.indexOf('apple pencil') === 0 || s.indexOf('pencil') === 0) return 'pencil';
    return null;
  }
  function catOf(m){ return LINE_CAT[lineOf(m)] || null; }
  function catByKey(k){ return CATS.filter(function(C){ return C.k === k; })[0]; }
  function clean(list){
    var out = [], per = {};
    (list || []).forEach(function(m){
      if (typeof m !== 'string' || ALL.indexOf(m) < 0 || out.indexOf(m) > -1) return;
      var c = catOf(m); per[c] = (per[c] || 0) + 1;
      if (per[c] <= MAX) out.push(m);
    });
    return out;
  }
  function saved(){
    var m = document.cookie.match(/(?:^|;\s*)sheep_my_device=([^;]+)/);
    if (!m) return [];
    try {
      var o = JSON.parse(decodeURIComponent(m[1]));
      if (Array.isArray(o)) return clean(o);
      if (o && typeof o === 'object') return clean(Object.keys(o).map(function(k){ return o[k]; }));
    } catch(e){}
    return [];
  }
  function put(list){
    var c = clean(list);
    document.cookie = KEY + '=' + encodeURIComponent(JSON.stringify(c)) + '; path=/; max-age=' + (c.length ? 31536000 : 0) + '; SameSite=Lax';
    return c;
  }
  function names(a){ return a.map(esc).join(', '); }
  function marks(a){ return '<mark class="smd-mk smd-mk--static">' + a.map(esc).join('</mark>, <mark class="smd-mk smd-mk--static">') + '</mark>'; }

  /* ---------- SHEEP AI: every chat request carries the saved devices ---------- */
  if (window.fetch && !window.__smdFetch) {
    window.__smdFetch = 1;
    var _f = window.fetch;
    window.fetch = function(input, init){
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/sheep-ai-assistant\.netlify\.app\/api\/chat/.test(url) && init && typeof init.body === 'string') {
          var mine = saved();
          if (mine.length) {
            var b = JSON.parse(init.body);
            b.page = b.page || {};
            var note = ' (SHEEP Device ที่ลูกค้าบันทึกไว้: ' + mine.join(', ') + ' — ห้ามถามรุ่นเครื่องซ้ำ ให้หาสินค้าสำหรับเครื่องเหล่านี้ทันที ถ้าคำขอเข้าได้หลายเครื่อง ให้เสนอสินค้าแยกตามเครื่อง (เช่น เคสสำหรับมือถือแต่ละเครื่อง) แล้วถามสั้นๆ ว่าอยากดูเครื่องไหนเพิ่ม ถ้าลูกค้าพูดถึงรุ่นอื่นให้ใช้ตามที่ลูกค้าพูด)';
            if (String(b.page.path || '').indexOf('SHEEP Device ที่ลูกค้า') < 0) b.page.path = (b.page.path || location.pathname) + note;
            b.my_device = mine;
            init = Object.assign({}, init, { body: JSON.stringify(b) });
          }
        }
      } catch(e){}
      return _f.call(this, input, init);
    };
  }

  /* ---------- matching a saved model to a variant / chip text ---------- */
  var LINE_WORDS = /iphone|galaxy|samsung|oppo|airpods|magsafe/g;
  function keyOf(m){ return m.toLowerCase().replace(LINE_WORDS, '').replace(/[^a-z0-9]/g, ''); }
  function keyParts(t){
    t = String(t).toLowerCase().replace(/\([^)]*\)/g, ' ').replace(LINE_WORDS, ' ');
    var parts = t.split(/[\/,&|]+/).map(function(p){ return p.replace(/[^a-z0-9]/g, ''); }).filter(Boolean);
    if (!parts.length) return [];
    var pre = parts[0].replace(/\d+[a-z]*$/, '');
    return parts.map(function(p, i){ return (i > 0 && /^\d+[a-z]*$/.test(p)) ? pre + p : p; });
  }
  function ipadInfo(t, isModel){
    t = String(t).toLowerCase().replace(/[“”″]/g, '"');
    var fam = [];
    if (/ipad pro\b/.test(t)) fam.push('pro');
    if (/\bair\b/.test(t)) fam.push('air');
    if (/\bmini\b/.test(t)) fam.push('mini');
    if (!fam.length) fam.push('base');
    if (isModel) fam = [fam.indexOf('mini') > -1 ? 'mini' : fam.indexOf('air') > -1 ? 'air' : fam.indexOf('pro') > -1 ? 'pro' : 'base'];
    var chips = t.match(/\b(m[1-5]|a1[67])\b/g) || [], gens = [], sizes = [], m;
    if (isModel) {
      m = t.match(/(\d+)(?:st|nd|rd|th) gen/); if (m) gens.push(+m[1]);
      m = t.match(/\b(?:mini|air)\s+(\d+)\b(?![."\d])/); if (m) gens.push(+m[1]);
      (t.match(/\d+(?:\.\d+)?"/g) || []).forEach(function(s){ sizes.push(parseFloat(s)); });
    } else {
      (t.split('(')[0].match(/\b\d+\.\d+\b|\b1[13]\b/g) || []).forEach(function(s){ sizes.push(parseFloat(s)); });
      var re = /(?:gen|air|mini)\s*([\d\s\/–\-,]+)/g;
      while ((m = re.exec(t))) {
        m[1].split(/[\/,]/).forEach(function(part){
          var r = part.trim().split(/\s*[–-]\s*/);
          if (r.length === 2 && r[0] && r[1]) { for (var i = +r[0]; i <= +r[1]; i++) gens.push(i); }
          else if (/^\d+$/.test(r[0])) gens.push(+r[0]);
        });
      }
    }
    return { fam: fam, chips: chips, gens: gens, sizes: sizes.map(function(s){ return s === 10.9 ? 11 : s; }) };
  }
  function meet(a, b){ return a.some(function(x){ return b.indexOf(x) > -1; }); }
  function ipadMatch(model, text){
    var M = ipadInfo(model, true), V = ipadInfo(text, false);
    if (V.fam.indexOf(M.fam[0]) < 0) return false;
    if (M.sizes.length && V.sizes.length && !meet(M.sizes, V.sizes)) return false;
    if (M.chips.length && V.chips.length && meet(M.chips, V.chips)) return true;
    if (M.gens.length && V.gens.length && meet(M.gens, V.gens)) return true;
    if ((M.chips.length || M.gens.length) && (V.chips.length || V.gens.length)) return false;
    return true;
  }
  function macInfo(t){
    t = String(t).toLowerCase().replace(/[“”″]/g, '"');
    var head = t.split('(')[0];
    var fam = /\bair\b/.test(head) ? 'air' : /\bpro\b/.test(head) ? 'pro' : '';
    var sm = t.match(/macbook\s+(?:air|pro)\s+(\d+(?:\.\d+)?)/), size = sm ? parseFloat(sm[1]) : null;
    if (fam === 'air' && size === 13) size = 13.6;
    var years = [], r = t.match(/(20\d\d)\s*[–-]\s*(20\d\d)/);
    if (r) { for (var y = +r[1]; y <= +r[2]; y++) years.push(y); }
    else (t.match(/20\d\d/g) || []).forEach(function(y){ years.push(+y); });
    return { fam: fam, size: size, chips: t.match(/\bm[1-5]\b/g) || [], years: years };
  }
  function macMatch(model, text){
    var M = macInfo(model), V = macInfo(text);
    if (!M.fam || M.fam !== V.fam || M.size === null || M.size !== V.size) return false;
    if (M.chips.length) return V.chips.length ? meet(M.chips, V.chips) : true;
    if (M.years.length && V.years.length) return meet(M.years, V.years);
    return !V.chips.length;
  }
  function pencilGen(t){
    t = String(t).toLowerCase();
    if (/\bpro\b/.test(t)) return 'pro';
    if (/usb-?c/.test(t)) return 'usbc';
    if (/2nd|\b2\b/.test(t)) return '2';
    if (/1st|\b1\b/.test(t)) return '1';
    return '';
  }
  function fitsText(model, text){
    var line = lineOf(model), tl = lineOf(text);
    if (norm(text) === norm(model)) return true;
    if (tl && tl !== line) return false;
    if (line === 'ipad') return tl === 'ipad' && ipadMatch(model, text);
    if (line === 'macbook') return tl === 'macbook' && macMatch(model, text);
    if (line === 'pencil') return tl === 'pencil' && pencilGen(model) !== '' && pencilGen(model) === pencilGen(text);
    if (!tl && line !== 'iphone') return false;
    return keyParts(text).indexOf(keyOf(model)) > -1;
  }

  /* ---------- picker ---------- */
  function guess(){
    if (!/iPhone/.test(navigator.userAgent)) return [];
    var w = Math.min(screen.width, screen.height), h = Math.max(screen.width, screen.height);
    var G = {
      '440x956':['iPhone 18 Pro Max','iPhone 17 Pro Max','iPhone 16 Pro Max'],
      '402x874':['iPhone 18 Pro','iPhone 17 Pro','iPhone 17','iPhone 16 Pro'],
      '420x912':['iPhone Air'],
      '393x852':['iPhone 16','iPhone 15 Pro','iPhone 15','iPhone 14 Pro'],
      '430x932':['iPhone 16 Plus','iPhone 15 Pro Max','iPhone 15 Plus','iPhone 14 Pro Max'],
      '390x844':['iPhone 16e','iPhone 14','iPhone 13 Pro','iPhone 13','iPhone 12 Pro','iPhone 12'],
      '428x926':['iPhone 14 Plus','iPhone 13 Pro Max','iPhone 12 Pro Max'],
      '375x812':['iPhone 11 Pro'],
      '414x896':['iPhone 11 Pro Max','iPhone 11']
    };
    return G[w + 'x' + h] || [];
  }
  function optsHTML(C, val){
    var h = '<option value="">เลือกรุ่น…</option>';
    C.g.forEach(function(G){
      var o = G.m.map(function(m){ return '<option value="' + esc(m) + '"' + (val === m ? ' selected' : '') + '>' + esc(m) + '</option>'; }).join('');
      h += C.g.length > 1 ? '<optgroup label="' + esc(G.n) + '">' + o + '</optgroup>' : o;
    });
    return h;
  }
  function itemHTML(C, val){
    return '<div class="smd-item"><span class="smd-sel"><select data-cat="' + C.k + '" aria-label="' + esc(C.n) + '">' + optsHTML(C, val) + '</select></span><button type="button" class="smd-del" aria-label="ลบเครื่องนี้">&times;</button></div>';
  }
  function refreshAdd(sec){
    var n = sec.querySelectorAll('.smd-item').length, add = sec.querySelector('.smd-add');
    if (add) add.hidden = n >= MAX;
    sec.classList.toggle('is-single', n <= 1);
  }
  function closePanel(){ var o = document.querySelector('.smd-pick'); if (o) o.remove(); document.documentElement.classList.remove('smd-lock'); }
  function openPanel(focusCat){
    closePanel();
    var d = saved();
    var secs = CATS.map(function(C){
      var mine = d.filter(function(m){ return catOf(m) === C.k; });
      if (!mine.length) mine = [''];
      var hint = '';
      if (C.k === 'phone') {
        var g = guess();
        if (g.length) hint = '<div class="smd-hint"><span>ขนาดจอเครื่องนี้ตรงกับ</span>' + g.map(function(m){ return '<button type="button" class="smd-chip" data-m="' + esc(m) + '">' + esc(m.replace('iPhone ', '')) + '</button>'; }).join('') + '</div>';
      }
      return '<div class="smd-row" data-cat="' + C.k + '">' +
        '<div class="smd-row__head"><span class="smd-row__name">' + esc(C.n) + '</span>' + (C.sub ? '<span class="smd-row__sub">' + esc(C.sub) + '</span>' : '') + '</div>' +
        '<div class="smd-list">' + mine.map(function(m){ return itemHTML(C, m); }).join('') + '</div>' +
        '<button type="button" class="smd-add">+ เพิ่ม' + esc(C.n) + 'อีกเครื่อง</button>' + hint + '</div>';
    }).join('');
    var o = document.createElement('div');
    o.className = 'smd-pick'; o.setAttribute('role', 'dialog'); o.setAttribute('aria-modal', 'true'); o.setAttribute('aria-labelledby', 'smdTitle');
    o.innerHTML =
      '<div class="smd-box">' +
        '<button type="button" class="smd-x" aria-label="ปิด">&times;</button>' +
        '<p class="smd-eyebrow">SHEEP DEVICE</p>' +
        '<h2 class="smd-title" id="smdTitle">SHEEP Device</h2>' +
        '<p class="smd-sub">บอกรุ่นเครื่องของคุณครั้งเดียว เราจะ<mark class="smd-mk smd-mk--static">ไฮไลต์สีส้ม</mark>รุ่นของคุณไว้ทุกจุด ทั้งเมนู ตัวกรอง และตัวเลือกสินค้า เช็ครุ่นให้ก่อนสั่งซื้อ · SHEEP AI ก็จะรู้ด้วย<br>หมวดละสูงสุด ' + MAX + ' เครื่อง · สินค้าทั้งหมดยังแสดงครบ คุณเลือกเองได้เสมอ</p>' +
        '<div class="smd-rows">' + secs + '</div>' +
        '<div class="smd-actions"><button type="button" class="smd-clear">ล้างทั้งหมด</button><button type="button" class="smd-save">บันทึก</button></div>' +
      '</div>';
    document.body.appendChild(o);
    document.documentElement.classList.add('smd-lock');
    o.querySelectorAll('.smd-row').forEach(refreshAdd);
    o.addEventListener('click', function(e){
      if (e.target === o || e.target.closest('.smd-x')) { closePanel(); return; }
      var sec = e.target.closest('.smd-row'), C = sec ? catByKey(sec.getAttribute('data-cat')) : null;
      var chip = e.target.closest('.smd-chip');
      if (chip) {
        var sels = [].slice.call(o.querySelectorAll('select[data-cat="phone"]'));
        var target = sels.filter(function(s){ return !s.value; })[0];
        if (!target && sels.length < MAX) { o.querySelector('.smd-row[data-cat="phone"] .smd-list').insertAdjacentHTML('beforeend', itemHTML(catByKey('phone'), '')); refreshAdd(o.querySelector('.smd-row[data-cat="phone"]')); target = [].slice.call(o.querySelectorAll('select[data-cat="phone"]')).pop(); }
        if (!target) target = sels[0];
        target.value = chip.getAttribute('data-m');
        chip.classList.add('is-on');
        return;
      }
      if (e.target.closest('.smd-add') && C) {
        sec.querySelector('.smd-list').insertAdjacentHTML('beforeend', itemHTML(C, ''));
        refreshAdd(sec);
        var ss = sec.querySelectorAll('select'); ss[ss.length - 1].focus();
        return;
      }
      var del = e.target.closest('.smd-del');
      if (del && sec) {
        var it = del.closest('.smd-item');
        if (sec.querySelectorAll('.smd-item').length > 1) it.remove(); else it.querySelector('select').value = '';
        refreshAdd(sec);
        return;
      }
      if (e.target.closest('.smd-clear')) {
        o.querySelectorAll('.smd-row').forEach(function(s){ var items = s.querySelectorAll('.smd-item'); for (var i = 1; i < items.length; i++) items[i].remove(); s.querySelector('select').value = ''; refreshAdd(s); });
        return;
      }
      if (e.target.closest('.smd-save')) {
        var list = [];
        o.querySelectorAll('select').forEach(function(s){ if (s.value) list.push(s.value); });
        var c2 = put(list);
        closePanel();
        clearMarks();
        run();
        toast(c2.length ? 'บันทึก SHEEP Device ' + c2.length + ' เครื่องแล้ว · SHEEP AI รู้รุ่นของคุณแล้ว' : 'ล้าง SHEEP Device แล้ว');
      }
    });
    document.addEventListener('keydown', function k(e){ if (e.key === 'Escape') { closePanel(); document.removeEventListener('keydown', k); } });
    var f = o.querySelector('.smd-row[data-cat="' + (focusCat || 'phone') + '"]');
    if (f) { if (focusCat) f.scrollIntoView({ block: 'center' }); var fs = f.querySelector('select'); if (fs) fs.focus({ preventScroll: true }); }
  }
  function toast(msg){
    var t = document.createElement('div'); t.className = 'smd-toast'; t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function(){ t.classList.add('is-out'); }, 2000);
    setTimeout(function(){ t.remove(); }, 2500);
  }

  /* ---------- header icon ---------- */
  var ICON = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="2.5" width="12" height="19" rx="3"/><path d="M10.5 5.5h3"/></svg>';
  function addBtns(){
    var n = saved().length;
    document.querySelectorAll('.site-nav__icons').forEach(function(box){
      var a = box.querySelector('.smd-btn');
      if (!a) {
        a = document.createElement('a');
        a.href = '#'; a.className = 'site-nav__link site-nav__link--icon smd-btn';
        a.setAttribute('aria-label', 'SHEEP Device'); a.title = 'SHEEP Device';
        a.innerHTML = ICON + '<span class="smd-dot" aria-hidden="true"></span>';
        var first = null;
        for (var i = 0; i < box.children.length; i++) {
          var ch = box.children[i];
          if (/(^|\s)sx-/.test(ch.className)) continue;
          if (ch.matches('a.site-nav__link--icon') || ch.querySelector('.site-nav__link--icon')) { first = ch; break; }
        }
        if (first) box.insertBefore(a, first); else box.appendChild(a);
      }
      var dot = a.querySelector('.smd-dot'), txt = n > 1 ? String(n) : '';
      if (dot && dot.textContent !== txt) dot.textContent = txt;
    });
    document.documentElement.classList.toggle('smd-has', n > 0);
  }

  /* ---------- highlighter ---------- */
  function mark(el, cls){ if (el && !el.classList.contains(cls)) el.classList.add(cls); }
  function wrapMark(el){
    if (!el || el.querySelector('.smd-mk-in')) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      if (!n.nodeValue.trim() || (n.parentNode.closest && n.parentNode.closest('svg'))) continue;
      var s = document.createElement('span'); s.className = 'smd-mk smd-mk-in';
      var lead = n.nodeValue.match(/^\s*/)[0], trail = n.nodeValue.match(/\s*$/)[0];
      s.textContent = n.nodeValue.trim();
      var frag = document.createDocumentFragment();
      if (lead) frag.appendChild(document.createTextNode(lead));
      frag.appendChild(s);
      if (trail) frag.appendChild(document.createTextNode(trail));
      n.parentNode.replaceChild(frag, n);
      return;
    }
  }
  function addDot(el){
    if (!el || el.querySelector('.smd-ldot')) return;
    var d = document.createElement('span'); d.className = 'smd-ldot'; d.setAttribute('aria-hidden', 'true');
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, last = null;
    while ((n = w.nextNode())) { if (n.nodeValue.trim()) last = n; }
    if (last) last.parentNode.insertBefore(d, last.nextSibling); else el.appendChild(d);
  }
  function clearMarks(){
    document.querySelectorAll('.smd-mk-in').forEach(function(s){ s.replaceWith(document.createTextNode(s.textContent)); });
    document.querySelectorAll('.smd-ldot, .smd-card-tag').forEach(function(e){ e.remove(); });
    ['smd-mk','smd-ring','smd-row-hl','smd-grp-hl'].forEach(function(c){ document.querySelectorAll('.' + c + ':not(.smd-mk--static)').forEach(function(e){ e.classList.remove(c); }); });
    document.querySelectorAll('[data-smd-auto]').forEach(function(e){ e.removeAttribute('data-smd-auto'); });
  }
  function ownText(el){
    var t = '';
    for (var i = 0; i < el.childNodes.length; i++) { var n = el.childNodes[i]; if (n.nodeType === 3) t += n.nodeValue; else if (n.nodeType === 1 && !/^(svg|small)$/i.test(n.tagName) && !n.classList.contains('smd-ldot')) t += n.textContent; }
    return t;
  }
  /* SPEED (1 Nov 2026): menu links are checked once each (data-smd-seen), not again on every page change */
  function highlight(){
    var mine = saved();
    if (!mine.length) return;
    var want = {}; mine.forEach(function(m){ want[norm(m)] = m; });
    var lines = {}; mine.forEach(function(m){ lines[lineOf(m)] = 1; });

    /* 1) SHOP BY DEVICE menu (desktop mega menu + phone drawer) */
    document.querySelectorAll('.site-header a:not([data-smd-seen]), #NavDrawer a:not([data-smd-seen]), .site-header summary:not([data-smd-seen]), #NavDrawer button:not([data-smd-seen])').forEach(function(a){
      a.setAttribute('data-smd-seen', '1');
      if (a.closest('.smd-pick, .sai-root, .sx-mode')) return;
      var t = norm(ownText(a));
      if (!t) return;
      if (want[t]) { wrapMark(a); return; }
      var l = MENU_LINE[t];
      if (l && lines[l]) addDot(a);
    });

    /* 2) Filter "รุ่น" — marked, group opened once, NOT ticked. Highlight only: clicks work normally. */
    document.querySelectorAll('.tag__text').forEach(function(s){
      if (!want[norm(s.textContent)]) return;
      mark(s, 'smd-mk');
      mark(s.closest('li'), 'smd-row-hl');
      var g = s.closest('details.sheep-mg');
      if (g) { if (!g.hasAttribute('data-smd-auto')) { g.setAttribute('data-smd-auto', '1'); g.open = true; } mark(g.querySelector('.sheep-mg__name'), 'smd-grp-hl'); }
      var grp = s.closest('.collection-sidebar__group, .filter-group, details');
      if (grp && grp !== g && !grp.hasAttribute('data-smd-auto')) { grp.setAttribute('data-smd-auto', '1'); if (grp.tagName === 'DETAILS') grp.open = true; }
    });

    /* 3) Product cards that fit */
    document.querySelectorAll('.grid-product[data-models]').forEach(function(card){
      if (card.querySelector('.smd-card-tag')) return;
      var ms = (card.getAttribute('data-models') || '').split('|');
      var hits = mine.filter(function(m){ return ms.indexOf(m) > -1; });
      if (!hits.length) return;
      var meta = card.querySelector('.grid-product__meta');
      if (!meta) return;
      var tag = document.createElement('div');
      tag.className = 'smd-card-tag';
      var label = hits.slice(0, 2).map(esc).join(', ') + (hits.length > 2 ? ' +' + (hits.length - 2) : '');
      tag.innerHTML = '<span class="smd-mk">✓ ใส่กับ ' + label + ' ได้</span>';
      meta.insertBefore(tag, meta.firstChild);
    });

    /* 4) SHEEP STUDIO model chips */
    document.querySelectorAll('.ss-chip').forEach(function(b){
      var t = b.textContent;
      if (mine.some(function(m){ return fitsText(m, t); })) { mark(b, 'smd-ring'); wrapMark(b); }
    });
  }

  /* ---------- collection hint bar (customer presses the buttons) ---------- */
  var modelPage = !!(HANDLE && /^(iphone|ipad|airpods|samsung-galaxy|oppo|macbook|apple-pencil)-/.test(HANDLE));
  function urlWith(add, drop){
    var u = new URL(location.href), cur = u.searchParams.getAll(P);
    u.searchParams.delete(P);
    cur.forEach(function(v){ if (drop.indexOf(v) < 0) u.searchParams.append(P, v); });
    add.forEach(function(v){ if (u.searchParams.getAll(P).indexOf(v) < 0) u.searchParams.append(P, v); });
    u.searchParams.delete('page');
    return u.href;
  }
  function bar(){
    if (PT !== 'collection' || !CM || !CM.length || modelPage) return;
    var old = document.querySelector('.smd-bar');
    var pageLines = {}; CM.forEach(function(m){ var l = lineOf(m); if (l) pageLines[l] = 1; });
    var mine = saved(), rel = mine.filter(function(m){ return pageLines[lineOf(m)]; });
    var cur = new URL(location.href).searchParams.getAll(P);
    var on = rel.filter(function(m){ return cur.indexOf(m) > -1; }), avail = rel.filter(function(m){ return CM.indexOf(m) > -1; });
    var html = '';
    if (on.length) {
      html = '<span class="smd-bar__t"><span class="smd-spark">✦</span> กำลังกรองเฉพาะ ' + marks(on) + ' ของคุณ</span><span class="smd-bar__b"><button type="button" class="is-main" data-smd-all>ดูสินค้าทั้งหมด</button><button type="button" data-smd-open>ตั้งค่า SHEEP Device</button></span>';
    } else if (avail.length) {
      html = '<span class="smd-bar__t"><span class="smd-spark">✦</span> สินค้าที่ใส่กับ ' + marks(avail) + ' ของคุณได้ มีป้ายสีส้มกำกับไว้</span><span class="smd-bar__b"><button type="button" data-smd-only>กรองเฉพาะรุ่นของฉัน</button><button type="button" data-smd-open>ตั้งค่า SHEEP Device</button></span>';
    } else if (rel.length) {
      html = '<span class="smd-bar__t"><span class="smd-spark">✦</span> หน้านี้ยังไม่มีสินค้าสำหรับ ' + marks(rel) + ' ของคุณ</span><span class="smd-bar__b"><button type="button" data-smd-open>ตั้งค่า SHEEP Device</button></span>';
    } else if (!mine.length) {
      html = '<span class="smd-bar__t"><span class="smd-spark">✦</span> บอกรุ่นมือถือ · iPad · AirPods · MacBook · Apple Pencil ของคุณใน SHEEP Device แล้วเราจะไฮไลต์สีส้มสินค้าที่ใส่ได้ให้</span><span class="smd-bar__b"><button type="button" class="is-main" data-smd-open>ตั้งค่า SHEEP Device</button></span>';
    }
    if (!html) { if (old) old.remove(); return; }
    var anchor = document.querySelector('#CollectionAjaxContent .collection-filter') || document.querySelector('.collection-filter');
    var parent = anchor ? anchor.parentNode : document.querySelector('#CollectionAjaxContent');
    if (!parent) return;
    if (old && old.getAttribute('data-h') === html && old.parentNode === parent) return;
    if (old) old.remove();
    var b = document.createElement('div');
    b.className = 'smd-bar sx-keep'; b.setAttribute('data-h', html); b.innerHTML = html;
    parent.insertBefore(b, anchor || parent.firstChild);
  }
  function myOnPage(){ var mine = saved(); return (CM || []).length ? mine.filter(function(m){ return CM.indexOf(m) > -1; }) : []; }

  /* ---------- product page: outline + marker on every matching variant + badge (no auto-select) ---------- */
  function optRadios(){
    if (!OPT) return [];
    var suf = '-' + OPT;
    var radios = [].slice.call(document.querySelectorAll('input[type=radio]')).filter(function(i){ return i.name && i.name.slice(-suf.length) === suf && !i.closest('.sai-root'); });
    var main = radios.filter(function(i){ return i.name.indexOf('__main') > -1; });
    return main.length ? main : radios;
  }
  function product(){
    if (PT !== 'product') return;
    var radios = optRadios();
    var has = {};
    (COMPAT || []).forEach(function(m){ var l = lineOf(m); if (l) has[l] = 1; });
    radios.forEach(function(r){ var l = lineOf(r.value); if (l) has[l] = 1; });
    var badge = document.querySelector('.smd-badge');
    var lines = Object.keys(has);
    if (!lines.length) { if (badge) badge.remove(); return; }

    var mine = saved().filter(function(m){ return has[lineOf(m)]; }), html, cls;
    if (mine.length) {
      var matched = radios.filter(function(r){ return mine.some(function(m){ return fitsText(m, r.value); }); });
      matched.forEach(function(r){ var s = r.nextElementSibling || r.parentNode; mark(s, 'smd-ring'); wrapMark(s); });
      var fitsModels = mine.filter(function(m){ return radios.some(function(r){ return fitsText(m, r.value); }) || (COMPAT && COMPAT.indexOf(m) > -1); });
      var checked = radios.filter(function(r){ return r.checked; })[0];
      var checkedFits = checked ? mine.filter(function(m){ return fitsText(m, checked.value); }) : [];
      if (!fitsModels.length) { cls = 'is-no'; html = '<span class="smd-badge__i">!</span><span class="smd-badge__t">สินค้านี้ยังไม่มีรุ่นสำหรับ <b>' + names(mine) + '</b> ของคุณ</span>'; }
      else if (matched.length && checked && !checkedFits.length) { cls = 'is-warn'; html = '<span class="smd-badge__i">!</span><span class="smd-badge__t">รุ่นที่เลือกอยู่ไม่ตรงกับ SHEEP Device ของคุณ (' + marks(fitsModels) + ') · ตัวที่ใช่มีกรอบสีส้ม</span>'; }
      else if (matched.length && checkedFits.length) {
        var others = fitsModels.filter(function(m){ return checkedFits.indexOf(m) < 0; });
        cls = 'is-ok'; html = '<span class="smd-badge__i">✓</span><span class="smd-badge__t">ตรงกับ ' + marks(checkedFits) + ' ของคุณแล้ว' + (others.length ? ' · มีรุ่นสำหรับ ' + marks(others) + ' ด้วย (กรอบสีส้ม)' : '') + '</span>';
      }
      else if (matched.length) { cls = 'is-ok'; html = '<span class="smd-badge__i">✦</span><span class="smd-badge__t">ใส่กับ ' + marks(fitsModels) + ' ของคุณได้ · เลือกตัวที่มีกรอบสีส้ม</span>'; }
      else { cls = 'is-ok'; html = '<span class="smd-badge__i">✓</span><span class="smd-badge__t">ใส่กับ ' + marks(fitsModels) + ' ของคุณได้</span>'; }
      html += '<button type="button" data-smd-open="' + (catOf(mine[0]) || '') + '">เปลี่ยน</button>';
    } else {
      var l0 = lines[0]; cls = 'is-ask';
      html = '<span class="smd-badge__i">?</span><span class="smd-badge__t">บอกรุ่น ' + esc(LN[l0] || l0) + ' ของคุณใน SHEEP Device แล้วเราจะไฮไลต์ตัวที่ใส่ได้ให้</span><button type="button" data-smd-open="' + (LINE_CAT[l0] || '') + '">ตั้งค่า</button>';
    }

    var anchor = null, after = true;
    if (radios.length) anchor = radios[0].closest('fieldset') || radios[0].parentNode;
    if (!anchor) { anchor = document.querySelector('#MainContent form[action*="/cart/add"]'); after = false; }
    if (!anchor) return;
    var key = cls + html;
    if (badge && badge.getAttribute('data-h') === key && (after ? badge.previousElementSibling === anchor : badge.nextElementSibling === anchor)) return;
    if (badge) badge.remove();
    var b = document.createElement('div');
    b.className = 'smd-badge ' + cls; b.setAttribute('data-h', key); b.innerHTML = html;
    if (after) anchor.parentNode.insertBefore(b, anchor.nextSibling); else anchor.parentNode.insertBefore(b, anchor);
  }

  /* ---------- clicks (only real SHEEP Device buttons — never the filter list) ---------- */
  document.addEventListener('click', function(e){
    var t = e.target.closest && e.target.closest('.smd-btn, button[data-smd-open], a[data-smd-open], button[data-smd-all], button[data-smd-only]');
    if (!t || t.closest('.smd-pick')) return;
    e.preventDefault();
    if (t.hasAttribute('data-smd-all')) { location.href = urlWith([], saved()); return; }
    if (t.hasAttribute('data-smd-only')) { location.href = urlWith(myOnPage(), []); return; }
    openPanel(t.getAttribute('data-smd-open') || null);
  });
  document.addEventListener('change', function(e){ if (e.target && e.target.type === 'radio') setTimeout(product, 60); });

  function run(){ addBtns(); bar(); product(); highlight(); }
  window.SheepMyDevice = { get: saved, open: openPanel, cats: CATS, fits: fitsText };
  function ready(){
    run();
    var t;
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(run, 200); }).observe(document.body, { childList: true, subtree: true });
  }
  /* after "บันทึก" the marks are cleared, so every menu link must be checked again */
  var _clear = clearMarks; clearMarks = function(){ _clear(); document.querySelectorAll('[data-smd-seen]').forEach(function(e){ e.removeAttribute('data-smd-seen'); }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
